// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__1BFqh","error":"Notification_error__vM3Qt","success":"Notification_success__hD_ex"};